import * as React from "react";
import Link from "next/link";
import { useOffers } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Heading, Panel, Separator, Text } from "@nju/ui";
import { formatPrice } from "@nju/utils";

export function FtthBanner() {
  const { ftth } = useOffers();
  const { indefiniteOffers } = ftth;

  const lowestPrice = React.useMemo(() => {
    return Math.min(
      ...indefiniteOffers.map((offer) => {
        return offer.totalRecurringPrice;
      }),
    );
  }, [indefiniteOffers]);

  return (
    <>
      <Panel
        forceShowTitleBlock={true}
        invisibleSeparator={true}
        separatorSize="none"
        testId="ftth-offer-banner"
      >
        <div className="h-full flex flex-col justify-between">
          <div>
            <Icon
              className="mr-3 w-6 h-6 from-tablet:w-8 from-tablet:h-8"
              name="globe"
              tone="accent"
            />
            <Separator
              size={{
                "@onlyMobile": "s",
                "@fromDesktop": "xs",
              }}
              tone="invisible"
            />
            <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
              nju światłowód
            </Heading>
            <BlockText className="mt-1" size="l">
              od {formatPrice(lowestPrice, false)} zł/mies.
            </BlockText>
            <Separator size="m" tone="invisible" />
          </div>
          <div>
            <Link
              href={portalRoutes.sprawdzDostepnosc.index.get()}
              passHref={true}
            >
              <A
                className="items-center gap-3"
                display="inlineFlex"
                size="inline"
                variant="simple"
              >
                <Text tone="accent">sprawdź dostępność</Text>
                <Icon height={18} name="arrow-right" tone="accent" width={18} />
              </A>
            </Link>
          </div>
        </div>
      </Panel>
    </>
  );
}
